function InitializePrizmCE() {

    $('.prizmce-checkbox input:checkbox', '#PrizmCEList').click(function (e) {
        UpdateSelectedPrizmCEItems();
    });

    UpdateSelectedPrizmCEItems();
}

function UpdateSelectedPrizmCEItems() {
    $('#SelectedPrizmCEItems').val("");

    $('.prizmce-checkbox', '#PrizmCEList').each(function (index, item) {
        var chk = $(item).find('input:checkbox');
        var chkSelected = $(item).find('input:checkbox:checked');
        if (chkSelected.length > 0) {
            var chkId = chk.attr('id');
            var selection = "~" + chkId + ":" + $("#Description" + chkId).html();
            $('#SelectedPrizmCEItems').val($('#SelectedPrizmCEItems').val() + selection);
        }
    });
}

function HideShowPrizmCEChildren(evt) {
    var key = evt.id;
    key = key.replace("Expand", "");

    if ($('#PrizmCEChildren' + key).css('display') == 'none') {
        $('#PrizmCEChildren' + key).show();
    }
    else {
        $('#PrizmCEChildren' + key).hide();
    }
}
